import React, { useState } from "react";
import axios from "axios";
import { guestbookSites, environment } from "../../../settings/IntegrationConstants";
import { Header, Subheader, HeaderContainer, L300, InputItem, T300Large, InputSection, Input, InputErrorText, PrimaryButton } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import WarningTriangle from "@/components/UI/Icons/WarningTriangle";
import I18n from "../../../translations/i18n";
import { numOfHotels } from "../../../settings/IntegrationConstants";


type LoginScreenProps = {
  hotelName: string;
  onJoinClick: () => void;
  onPassword: () => void;
  onGoogle: () => void;
  setUserData: (email: string, firstName: string) => void; 
};
const LoginScreen = ({ hotelName, onJoinClick, onPassword, onGoogle, setUserData }: LoginScreenProps) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("")
    const [error, setError] = useState(false)

  const onSubmitEmail = (e: React.FormEvent) => {
     e.preventDefault();
     setError(false)
    const submissionData = {
      email: email,
      wid: window.gb_data.widget.identifier,
    };
    axios
      .get(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/bei/user_type`,
        {
          params: submissionData,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          const userFirstName = response.data.first_name;
          setFirstName(userFirstName);
          setUserData(email, userFirstName);

          if (response.data.login_type === "google") {
            onGoogle()
          } else {
            onPassword()
          }

        }
      })
      .catch((error) => {
         setError(true)
    });
  };

  return (
    <form onSubmit={onSubmitEmail} style={{ width: "100%" }}>
      <HeaderContainer>
        <Header>
          {I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.header`)}
        </Header>
        <Subheader>
          {I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.subheader`, {hotel_name: hotelName, num_of_hotels: numOfHotels})}
        </Subheader>
      </HeaderContainer>
      <InputSection>
        <InputItem>
          <L300>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.email_address`)}</L300>
          <Input
            type="email"
            placeholder="example@email.com"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            required
            hasError={error}
          />
          {error && 
            <InputErrorText>
              <WarningTriangle/>
              {I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.warning`)}
            </InputErrorText>
          }
        </InputItem>
      </InputSection>
      <PrimaryButton type="submit">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.login`)}</PrimaryButton>
      <T300Large>
        {I18n.t(`views.hotel_integration.components.widget.mobile_modal.login.new_member`)}{" "}
        <span onClick={onJoinClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.join`)}</span>
      </T300Large>
      <TermsPrivacy/>
    </form>
  );
};
export default LoginScreen;